import { toRefs } from 'vue';
import { state } from './state';
import { isArray, isNil } from './utils';
export const useKeycloak = () => {
    return {
        ...toRefs(state),
        hasRoles: (roles) => isArray(roles) && state.isAuthenticated && roles.every(role => state.roles.includes(role)),
        hasResourceRoles: (roles, resource) => isArray(roles) &&
            !isNil(resource) &&
            state.isAuthenticated &&
            !isNil(state.resourceRoles) &&
            isArray(state.resourceRoles[resource]) &&
            roles.every(role => state.resourceRoles[resource].includes(role)),
    };
};
//# sourceMappingURL=composable.js.map